import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import { useState } from "react";
import MainTableRow from "./MainTableRow";

const MainTable = ({
  setAllTickets,
  allTickets,
  handleDelete,
  setReload,
  pagination,
  setPagination,
  loading,
  handleTableCheckBox,
  selectedRows,
  permissions,
}) => {
  const [openDesc, setOpenDesc] = useState("");

  const rows = allTickets;
  const columns = [
    { id: "title", label: "Title" },
    { id: "customer_name", label: "Customer Name" },
    { id: "project_name", label: "Project Name" },
    {
      id: "assignees",
      label: "Assigned",
      align: "center",
      style: { width: "120px" },
    },
    { id: "created_at", label: "Created At", style: { width: "120px" } },
    { id: "priority", label: "Priority", style: { width: "120px" } },
    { id: "status", label: "Status", style: { width: "120px" } },
    {
      id: "action",
      label: "Actions",
      style: { width: "170px" },
      align: "center",
    },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 257px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  "& .MuiTableCell-sizeMedium": {
                    padding: "10px 0px 10px 16px",
                  },
                  "& .MuiTableCell-sizeMedium:first-of-type": {
                    paddingLeft: "8px",
                    paddingRight: "0px",
                  },
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    disabled={!permissions["bulk action"]}
                    checked={
                      selectedRows?.length === allTickets?.length &&
                      allTickets?.length
                    }
                    onChange={(e) =>
                      handleTableCheckBox("all", e.target.checked)
                    }
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={column.style}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <MainTableRow
                  key={row.id}
                  row={row}
                  columns={columns}
                  span={columns?.length}
                  handleDelete={handleDelete}
                  setReload={setReload}
                  setOpenDesc={setOpenDesc}
                  openDesc={openDesc}
                  handleTableCheckBox={handleTableCheckBox}
                  selectedRows={selectedRows}
                  allTickets={allTickets}
                  setAllTickets={setAllTickets}
                  permissions={permissions}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 257px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Paper>
  );
};

export default MainTable;
